module.exports = __webpack_public_path__ + "static/hatbat-a143dc1fee4d5d435e5bb918404c9fef.png";